export default __webpack_public_path__ + "static/media/sales-background.a3f65e1f.svg";